
const {
	primary, accent, danger, error,
	CSS_COLORS, inquirer, newline,
	APP_ROOT, TEMPLATES_ROOT
} = require('../../common.js')
const _ 		= require('lodash')
const chalk 	= require('chalk')
const fs 		= require('fs')
const path 	= require('path')

const generatorLookup = {
	app: {
		alias: 'a',
		generator: null
	},
	changelog: {
		alias: 'ch',
		generator: require('./changelog.js')
	},
	component: {
		alias: 'c',
		generator: require('./component.js')
	},
	service: {
		alias: 's',
		generator: require('./service.js')
	}

}

function generate(yargs) {
	const argv = yargs
	.reset()
	.argv

	let type = argv._[1]
	const data = argv._.slice(2, argv._.length)


	if (type) {
		_routeToGenerator(type, data)
	} else {
		inquirer.prompt([{
			type: 'list',
			name: 'type',
			choices: Object.keys(generatorLookup),
			message: 'generate...'
		}]).then(({ type }) => {
			_routeToGenerator(type, data)
		})
	}

}

function _routeToGenerator(type, data) {

	let generator
	let name

	for (let key in generatorLookup) {
		if (type === key || type === generatorLookup[key].alias) {
			generator = generatorLookup[key].generator
			name = key
			break
		}
	}

	if (generator) {
		console.log(accent(`ops generate ${name} --`))
		generator(data)
	} else {

		const message = [
			`${danger(type)} is not a valid generator type`,
			`allowed types are:`
		]

		for (let key in generatorLookup) {
			message.push(`\t${
				accent(key
			)} (${
				accent(generatorLookup[key].alias)
			})`)
		}

		error('generate', message)
	}

}

module.exports = generate



// WEBPACK FOOTER //
// ./src/commands/generate/index.js